module.exports = __webpack_public_path__ + "static/media/Vintage_1.c63bfe59.jpg";